
<template lang="pug">
v-layout(row, wrap)
  v-flex.md12.Poppins
    v-card.cardPadrao
      v-card-text
        v-layout(row, wrap)
          v-flex.md6.xs4(style="display: flex; align-items: center;")
            h4.headline.font-weight-medium.Poppins Faturamento do Mês
          v-spacer
          v-flex.md6.xs8
            v-menu.xs12(offset-y, max-width="280px")
              template.xs12(v-slot:activator="{ on, attrs }")
                v-btn.mr-0.xs12.br-5.right(v-bind="attrs", v-on="on", height="33px", depressed, style="background-color: #1D9A5A; color: #fff;")
                  i.fa.fa-filter.pr-2
                  .Poppins {{ mesSelecionado ? mesSelecionado.label : 'Referência' }}
              v-card.pt-2
                v-list.listMeses
                  v-list-tile(v-for="mes in meses", :key="mes.value")
                    v-flex(md12, xs12, pa-0, justify-center, d-flex, style="flex-wrap: wrap; align-items: center;")
                      v-btn.ma-0.xs12.br-5(class="botaoItemFiltro", height="33px", @click="selectMes(mes)", depressed, :disabled="mesSelecionado && mesSelecionado.value === mes.value ? true : false")
                        span.Poppins {{ mes.label }}

        v-layout(row, wrap, v-if="exibirResultadoAnterior").mt-5
          v-flex.xs12
            v-list(three-line, style="background-color: transparent;").pa-0
              v-list-tile(@click="selectMes(mesAnterior)").cardMesAnterior
                v-list-tile-action
                  img(src="@/assets/images/icons/calendario.svg", width="60px")
                v-list-tile-content
                  v-list-tile-title.pl-3.title.Poppins Veja os resultados de {{ mesAnterior.label }}
                v-list-tile-action
                  v-icon(large) chevron_right

        v-layout(row, wrap).mt-5
          v-flex.xs12
            .body-1.Poppins.text-xs-right(v-if="$root.FIREBASE_REMOTE_CONFIG.NOVA_INTERFACE_FINANCEIRO && faturas.length")
              span(style="cursor: pointer;", @click="showFaturas(faturas)") veja detalhes
            v-layout(row, wrap).mt-2
              v-flex.xs12
                v-layout(row, wrap)
                  v-flex.xs12.md3
                    span.body-1.Poppins Resultado
                    .display-1.font-weight-bold.Poppins {{ resultado }}
                  v-flex.xs12.md9
                    .border-wrapper
                      v-layout(row, wrap).inner-layout
                        v-flex.xs12.md4.box.relative
                          .inner-box
                            span.subheading.font-weight-bold.verdeFinanceiro--text.Poppins.text-left {{ recebidoLoja | currency }}
                            .body-1.verdeFinanceiro--text.Poppins Recebido pela Loja
                          .separator
                        v-flex.xs12.md4.box.relative
                          .inner-box
                            span.subheading.font-weight-bold.verdeFinanceiro--text.Poppins {{ repassesRecebidos | currency}}
                            .body-1.verdeFinanceiro--text.Poppins Repasses recebidos
                          .separator
                        v-flex.xs12.md4.box
                          .inner-box(@click="openDialogRepasses()", :style="!$root.FIREBASE_REMOTE_CONFIG.NOVA_INTERFACE_FINANCEIRO ? {'cursor': 'pointer'} : {}")
                            span.subheading.font-weight-bold.Poppins {{ repasseDisponivel | currency}}
                            .body-1.Poppins {{repasseAgendado != repasseDisponivel || repasseDisponivel == 0 ? "Repasse disponível" : "Repasse agendado"}}
                              v-icon(v-if="(repasseDisponivel != 0 || repasseAgendado != 0) && !$root.FIREBASE_REMOTE_CONFIG.NOVA_INTERFACE_FINANCEIRO").pl-1 info

        v-divider.my-5

        v-layout(row, wrap, v-if="!faturas.length && loading").mt-3
          v-flex.xs12
            v-progress-linear(:indeterminate="true")
        v-layout(row, wrap, v-show="!loading")
          v-flex.xs-12
            h4.headline.verdeFinanceiro--text.font-weight-medium.Poppins {{$root.FIREBASE_REMOTE_CONFIG.NOVA_INTERFACE_FINANCEIRO ? "Repasses do Período" : "Faturas do Período"}}
        v-layout(row, wrap)
          v-flex.xs-12
            FaturasList(ref="faturasList", @showFatura="showFatura", v-show="!loading && !$root.FIREBASE_REMOTE_CONFIG.NOVA_INTERFACE_FINANCEIRO")
            RepassesList(ref="repassesList", @showFatura="showFatura", v-show="!loading && $root.FIREBASE_REMOTE_CONFIG.NOVA_INTERFACE_FINANCEIRO")

    fatura(ref="dialogFatura")
    DialogRepassesDisponiveis(ref="dialogRepassesDisponiveis")
    DialogFaturas(ref="dialogFaturas", @showFatura="showFatura")
</template>

<script>
import _ from "lodash";
import fatura from '@/pages/financeiro/fatura/Resumo';
import FaturasList from '@/pages/financeiro/fatura/Faturas';
import RepassesList from '@/pages/financeiro/fatura/Repasses';
import DialogRepassesDisponiveis from '@/pages/financeiro/repasse/DialogDisponiveis';
import DialogFaturas from '@/pages/financeiro/fatura/DialogFaturas';

export default {
  props: {
    openDialogRepasse: {
      type: Function,
      default: () => {},
    },
  },
  components: {
    fatura,
    FaturasList,
    RepassesList,
    DialogFaturas,
    DialogRepassesDisponiveis,
  },
  data () {
    return {
      dialog: {
        show: false,
        faturas: false,
      },
      faturas: [],
      faturas7meses: [],
      repasses: [],
      venda: null,
      loading: false,
      anos: [],
      ano: null,
      mesSelecionado: null,
    }
  },
  created () {
    window.getApp.$on("REFRESH_FATURAS", this.refreshData);
  },
  beforeDestroy() {
    window.getApp.$off("REFRESH_FATURAS", this.refreshData);
  },
  watch: {
    faturas: {
      deep: true,
      handler (val) {
        this.$forceUpdate();
      },
    },
  },
  computed: {
    estabelecimentoSelecionado(){
      return this.$root.estabelecimentoSelecionado;
    },
    meses () {
      const vm = this
      const meses = []
      if (!vm.venda || !vm.venda.data_adesao) {
        return meses
      }

      const dataAdesao = vm.$dayjs(vm.venda.data_adesao).startOf('month')
      const dataAtual = vm.$dayjs().startOf('month')
      const diffMeses = dataAtual.diff(dataAdesao, 'month')
      let count = 0

      while (count <= diffMeses) {
        const mes = dataAtual.subtract(count, 'month')
        meses.push({
          label: mes.format('MMMM YYYY').replace(/^./, char => char.toUpperCase()),
          value: mes.startOf('month').format('YYYY-MM-DD'),
        })
        count++
      }

      return meses
    },
    mesAnterior () {
      return this.meses.length > 1 ? this.meses[1] : null
    },
    exibirResultadoAnterior () {
      const vm = this
      const dataAtual = vm.$dayjs()
      const mesSelecionado = vm.mesSelecionado ? vm.$dayjs(vm.mesSelecionado.value) : null;
      const diaAtual = Number(dataAtual.format('DD'))
      const isMesAtual = mesSelecionado ? mesSelecionado.isSame(dataAtual, 'month') : false;
      const mesAnterior = vm.mesAnterior ? vm.$dayjs(vm.mesAnterior.value) : null;
      return isMesAtual && mesAnterior && diaAtual <= (vm.$root.isProduction ? 5 : 28);
    },
    resultado () {
      const vm = this

      const totalVendasOffline = _.sumBy(vm.faturas, fatura => fatura.indicadores.totalVendasOffline)
      const totalTaxaServicoOffline = _.sumBy(vm.faturas, fatura => fatura.indicadores.totalTaxaServicoDinheiro + fatura.indicadores.totalTaxaServicoMaquininha)
      const totalDescontosOffline = _.sumBy(vm.faturas, fatura => fatura.indicadores.totalDescontosOffline)
      const totalReembolsosPromocionaisOffline = _.sumBy(vm.faturas, fatura => fatura.indicadores.totalReembolsosPromocionaisOffline)

      const totalRecebidoLoja = (totalVendasOffline + totalTaxaServicoOffline) - totalReembolsosPromocionaisOffline - totalDescontosOffline

      const totalRepassesRealizados = _.sumBy(vm.faturas, fatura => _.sumBy(fatura.repasses, repasse => repasse.status === vm.$root.enums.STATUS.REPASSE_REALIZADO ? repasse.valor : 0))
      const totalRepassesDisponiveis = _.sumBy(vm.faturas, fatura => _.sumBy(fatura.repasses, repasse => !fatura.id && repasse.status === vm.$root.enums.STATUS.REPASSE_AGUARDANDO ? repasse.valor : 0))
      const totalRepassesAgendados = _.sumBy(vm.faturas, fatura => _.sumBy(fatura.repasses, repasse => fatura.id && repasse.status === vm.$root.enums.STATUS.REPASSE_AGUARDANDO ? repasse.valor : 0))

      const totalRepasses = totalRepassesRealizados + totalRepassesDisponiveis + totalRepassesAgendados;

      return vm.$options.filters.currency(totalRecebidoLoja + totalRepasses)
    },
    recebidoLoja () {
      const vm = this
      const totalVendasOffline = _.sumBy(vm.faturas, fatura => fatura.indicadores.totalVendasOffline)
      const totalDescontosOffline = _.sumBy(vm.faturas, fatura => fatura.indicadores.totalDescontosOffline)
      const totalReembolsosPromocionaisOffline = _.sumBy(vm.faturas, fatura => fatura.indicadores.totalReembolsosPromocionaisOffline)

      const totalTaxaServicoOffline = _.sumBy(vm.faturas, fatura => fatura.indicadores.totalTaxaServicoDinheiro + fatura.indicadores.totalTaxaServicoMaquininha)
      return (totalVendasOffline + totalTaxaServicoOffline) - totalReembolsosPromocionaisOffline - totalDescontosOffline
    },
    repassesRecebidos () {
      const vm = this
      const totalRepassesRealizados = _.sumBy(vm.faturas, fatura => _.sumBy(fatura.repasses, repasse => repasse.status === vm.$root.enums.STATUS.REPASSE_REALIZADO ? repasse.valor : 0))
      return totalRepassesRealizados;
    },
    repasseDisponivel () {
      const vm = this
      const totalRepassesDisponiveis = _.sumBy(vm.faturas, fatura => _.sumBy(fatura.repasses, repasse => !fatura.id && repasse.status === vm.$root.enums.STATUS.REPASSE_AGUARDANDO ? repasse.valor : 0))
      const totalRepassesAgendados = _.sumBy(vm.faturas, fatura => _.sumBy(fatura.repasses, repasse => fatura.id && repasse.status === vm.$root.enums.STATUS.REPASSE_AGUARDANDO ? repasse.valor : 0))
      return totalRepassesAgendados + totalRepassesDisponiveis;
    },
    repasseAgendado(){
      const vm = this
      const totalRepassesAgendados = _.sumBy(vm.faturas, fatura => _.sumBy(fatura.repasses, repasse => fatura.id && repasse.status === vm.$root.enums.STATUS.REPASSE_AGUARDANDO ? repasse.valor : 0))
      return totalRepassesAgendados;
    }
  },
  methods: {
    getRepassesDisponiveis(){
      const repasses = []
      const vm = this;
      vm.faturas.forEach(fatura => {
        fatura.repasses.forEach(repasse => {
          if (!fatura.id && repasse.status === vm.$root.enums.STATUS.REPASSE_AGUARDANDO) {
            repasses.push(repasse);
          } else if (repasse.status === vm.$root.enums.STATUS.REPASSE_AGUARDANDO) {
            repasses.push(repasse);
          }
        });
      });
      return repasses;
    },
    openDialogRepasses () {
      const repassesDisponiveis = this.getRepassesDisponiveis();
      if (!repassesDisponiveis.length || this.$root.FIREBASE_REMOTE_CONFIG.NOVA_INTERFACE_FINANCEIRO) {
        return;
      }
      this.$refs.dialogRepassesDisponiveis.open(repassesDisponiveis);
    },
    showFatura (fatura) {
      const vm = this;
      vm.$refs.dialogFatura.open(fatura);
    },
    showFaturas(faturas){
      const vm = this;
      vm.$refs.dialogFaturas.open(faturas);
    },
    showError (error) {
      const vm = this;
      let err = error.response && error.response.data ? error.response.data.error : 'Ocorreu um erro ao buscar as faturas. Atualize a página!';
      window.getApp.$emit('APP_ALERT', { color: 'red', text: err });
      vm.loading = false;
    },
    setVenda (venda) {
      const vm = this;
      vm.venda = venda;
    },
    refreshData () {
      this.selectMes(this.mesSelecionado);
    },
    async selectMes (mes) {
      const vm = this;
      vm.mesSelecionado = mes;
      const dataInicio = vm.$dayjs(mes.value, 'YYYY-MM-DD').startOf('month').format('YYYY-MM-DD');
      const dataFim = vm.$dayjs(mes.value, 'YYYY-MM-DD').endOf('month').format('YYYY-MM-DD');
      await vm.getFaturas(vm.venda, dataInicio, dataFim);
      vm.loading = false;
      console.log(vm.$refs.repassesList ? 'Repasses list exists' : 'Repasses list not exists');
      if(vm.$refs.faturasList)
        vm.$refs.faturasList.refresh(vm.faturas);
      if(vm.$refs.repassesList)
        vm.$refs.repassesList.refresh(vm.faturas);
    },
    update(venda){
      this.setVenda(venda);
      const meses = this.meses;
      this.mesSelecionado = this.mesSelecionado ? this.mesSelecionado : meses[0];
      this.selectMes(this.mesSelecionado);
    },
    async getFaturas (venda, dataInicio, dataFim) {
      const vm = this;
      try {
        vm.faturas = [];
        if (!venda) return;
        vm.loading = true;
        const { data: faturas } = await vm.$axios.get('/fatura/extrato', {
          params: {
            venda_id: venda.id,
            data_inicio: dataInicio,
            data_fim: dataFim,
          },
        });
        vm.faturas = faturas;
        vm.loading = false;

      } catch (error) {
        vm.showError(error);
      }
    },
  },
}
</script>

<style lang="scss">
.Poppins {
  font-family: "Poppins" !important;
}
.Capitalize {
  text-transform: capitalize;
}
.br-5 {
  border-radius: 5px !important;
}
.br-10 {
  border-radius: 10px !important;
}
.cardPadrao {
  box-shadow:none !important;
  background-color: transparent;
  margin-bottom: 25px;
}
.botaoItemFiltro {
  color: #111312cc;
  background-color: #eaeaea !important;
  text-transform: capitalize;
}
.cardFatura {
  width: 100%;
  // box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05);
  padding: 20px!important;
  border-radius: 10px;
  border: 1px solid #ccc;
}
.avisoBox {
  margin-top: 25px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.areaScrool {
  overflow-y: auto;
  height: 63vh;
  align-content: flex-start!important;
}
@media screen and (max-width: 960px) {
  .avisoBox img {
    width: 90%;
    height: auto;
    max-width: 500px;
    max-height: 500px;
  }
}
.listMeses {
  max-height: 500px!important;
  background-color: white!important;
  overflow-y: auto!important;
}
.cardMesAnterior {
  background-color: #eaeaea;
  border-radius: 10px;
}

.box {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.border-wrapper {
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 8px;
  height: 100%;
}
.relative {
  position: relative;
}
.separator {
  position: absolute;
  background: #ccc;
}
@media (min-width: 960px) {
  .separator {
    right: 0;
    top: 10%;
    width: 1px;
    height: 80%;
  }
}
@media (max-width: 959px) {
  .separator {
    bottom: 0;
    left: 5%;
    width: 90%;
    height: 1px;
  }
}
.inner-box {
  width: 100%;
  text-align: center;
}
.inner-layout {
  height: 100%;
}
</style>
